/**
 * AskmyPets — Filter Count Badges + Active-Filters-Bar Sync
 * Liest aktive Werte pro Snout-Filter-Dropdown aus dem DOM und
 * synct sie zu der amp-active-filters-bar Pills-Anzeige.
 *
 * WICHTIG:
 * 1) Snouts facets-horizontal UND facets-vertical werden BEIDE
 *    im DOM gerendert (Drawer + Sidebar/Desktop). Daher MUSS deduped werden,
 *    sonst erscheinen die Pills doppelt.
 * 2) applyBadges() mutiert Elemente innerhalb der beobachteten Container
 *    → idempotent halten, sonst Observer-Feedback-Loop und Flackern beim
 *    Hover über "Alle löschen".
 */
(function () {
  'use strict';

  // === Auto-Scroll nach Quiz-CTA: ?from_quiz=1 → scrollt zu Filter/Grid ===
  function computeScrollTarget() {
    var target =
      document.querySelector('.amp-active-filters-bar-wrapper') ||
      document.querySelector('#Product-Grid-Container');
    if (!target) return null;
    var headerEl = document.querySelector('.shopify-section-group-header-group, .header-wrapper, header');
    var headerH = headerEl ? headerEl.offsetHeight : 0;
    var rect = target.getBoundingClientRect();
    return Math.max(0, Math.round(rect.top + window.pageYOffset - headerH - 12));
  }

  function handleQuizScroll() {
    try {
      var url = new URL(window.location.href);
      if (url.searchParams.get('from_quiz') !== '1') return;
      url.searchParams.delete('from_quiz');
      var clean = url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '') + url.hash;
      history.replaceState(null, '', clean);
      try { history.scrollRestoration = 'manual'; } catch (e) {}
      var topPx = computeScrollTarget();
      if (topPx === null) return;
      window.scrollTo(0, topPx);
      var retries = 0;
      var lock = setInterval(function () {
        retries++;
        var current = window.pageYOffset;
        if (Math.abs(current - topPx) > 50) {
          window.scrollTo(0, topPx);
        }
        if (retries >= 6) clearInterval(lock);
      }, 200);
    } catch (e) { /* noop */ }
  }

  function startQuizScroll() {
    setTimeout(handleQuizScroll, 400);
  }
  if (document.readyState === 'complete') {
    startQuizScroll();
  } else {
    window.addEventListener('load', startQuizScroll, { once: true });
  }

  // === State-Cache: nur rendern wenn sich was geändert hat ===
  var lastPillsSignature = null;   // JSON-String aus [href, label] Paaren
  var lastBadgesSignature = null;  // JSON-String aus [summary-id, count] Paaren

  // === Active-Filter-Pills client-side aus Snouts AJAX-State synchronisieren ===
  function syncActiveFiltersBar() {
    // Snout rendert facets-horizontal + facets-vertical parallel → dedupe nach href.
    var allAnchors = document.querySelectorAll('.facets-active-values a.active-facet-value');
    var seenHrefs = {};
    var snoutAnchors = [];
    allAnchors.forEach(function (a) {
      var href = a.getAttribute('href') || '';
      if (!seenHrefs[href]) {
        seenHrefs[href] = true;
        snoutAnchors.push(a);
      }
    });

    // === IDEMPOTENZ-GUARD: Signature aus aktiven Anchors bilden ===
    var sig = snoutAnchors.map(function (a) {
      return (a.getAttribute('href') || '') + '|' + (a.textContent || '').replace(/\s+/g, ' ').trim();
    }).join('###');

    if (sig === lastPillsSignature) {
      return; // nichts geändert → nicht neu rendern → kein Flackern
    }
    lastPillsSignature = sig;

    var count = snoutAnchors.length;
    var existingWrapper = document.querySelector('.amp-active-filters-bar-wrapper');

    if (count === 0) {
      if (existingWrapper) existingWrapper.style.display = 'none';
      return;
    }

    var collectionUrl = window.location.pathname;

    var wrapper = existingWrapper;
    var bar;
    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.className = 'page-width amp-active-filters-bar-wrapper';
      bar = document.createElement('div');
      bar.className = 'amp-active-filters-bar';
      wrapper.appendChild(bar);
      var insertBefore = document.querySelector('.content-grid-main') || document.querySelector('#Product-Grid-Container');
      if (insertBefore && insertBefore.parentNode) {
        insertBefore.parentNode.insertBefore(wrapper, insertBefore);
      } else {
        return;
      }
    } else {
      wrapper.style.display = '';
      bar = wrapper.querySelector('.amp-active-filters-bar') || wrapper;
    }

    bar.innerHTML = '';

    var label = document.createElement('span');
    label.className = 'amp-active-filters-bar__label';
    label.textContent = (count > 1 ? 'Aktive Filter' : 'Aktiver Filter') + ':';
    bar.appendChild(label);

    snoutAnchors.forEach(function (a) {
      var href = a.getAttribute('href') || '#';
      var raw = (a.textContent || '').replace(/\s+/g, ' ').replace(/×/g, '').trim();
      var pill = document.createElement('a');
      pill.className = 'amp-active-filter-pill';
      pill.setAttribute('href', href);

      var idx = raw.indexOf(':');
      if (idx > 0) {
        var labelText = raw.slice(0, idx).trim();
        var valueText = raw.slice(idx + 1).trim();
        var strong = document.createElement('strong');
        strong.textContent = labelText + ': ';
        pill.appendChild(strong);
        pill.appendChild(document.createTextNode(valueText));
      } else {
        pill.textContent = raw;
      }

      var remove = document.createElement('span');
      remove.className = 'amp-active-filter-pill__remove';
      remove.setAttribute('aria-hidden', 'true');
      remove.textContent = '×';
      pill.appendChild(remove);

      bar.appendChild(pill);
    });

    var clearWrap = document.createElement('span');
    clearWrap.className = 'amp-active-filters-bar__clear-wrap';
    var clearAll = document.createElement('a');
    clearAll.className = 'amp-active-filters-bar__clear-all';
    clearAll.setAttribute('href', collectionUrl);
    clearAll.textContent = 'Alle löschen';
    clearWrap.appendChild(clearAll);
    bar.appendChild(clearWrap);
  }

  function applyBadges() {
    var summaries = document.querySelectorAll('.facets-summary');

    // === IDEMPOTENZ-GUARD: Signature aus (summary, count) Paaren ===
    var sigParts = [];
    var prepared = [];
    summaries.forEach(function (summary) {
      var ariaLabel = summary.getAttribute('aria-label') || '';
      var match = ariaLabel.match(/\((\d+)\s+\w+\)/);
      var count = match ? parseInt(match[1], 10) : 0;
      if (!count) {
        var selectedSpan = summary.querySelector('.facets-selected');
        if (selectedSpan) {
          var innerMatch = selectedSpan.textContent.match(/\((\d+)\)/);
          if (innerMatch) count = parseInt(innerMatch[1], 10);
        }
      }
      var key = summary.getAttribute('data-facet-id') || summary.id || summary.getAttribute('aria-label') || '';
      sigParts.push(key + '=' + count);
      prepared.push({ summary: summary, count: count });
    });
    var sig = sigParts.join('|');
    if (sig === lastBadgesSignature) {
      return; // nichts geändert → nicht neu rendern
    }
    lastBadgesSignature = sig;

    prepared.forEach(function (item) {
      var summary = item.summary;
      var count = item.count;
      var oldBadge = summary.querySelector('.amp-filter-active-count');
      if (oldBadge) oldBadge.remove();
      if (count > 0) {
        var badge = document.createElement('span');
        badge.className = 'amp-filter-active-count';
        badge.setAttribute('aria-hidden', 'true');
        badge.textContent = count;
        summary.classList.add('has-active');
        var caret = summary.querySelector('svg, .icon-caret, [class*="caret"]');
        if (caret && caret.parentElement === summary) {
          summary.insertBefore(badge, caret);
        } else {
          summary.appendChild(badge);
        }
      } else {
        summary.classList.remove('has-active');
      }
    });
  }

  function runAll() {
    applyBadges();
    syncActiveFiltersBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAll);
  } else {
    runAll();
  }

  var rescanScheduled = false;
  var observer = new MutationObserver(function () {
    if (rescanScheduled) return;
    rescanScheduled = true;
    setTimeout(function () {
      rescanScheduled = false;
      runAll();
    }, 150);
  });

  var targets = ['#Facet-Horizontal-Wrapper', '#Facet-Vertical-Wrapper', '#Facet-Drawer-Wrapper', '#Product-Grid-Container', '.facets-group'];
  targets.forEach(function (sel) {
    var el = document.querySelector(sel);
    if (el) observer.observe(el, { childList: true, subtree: true });
  });
})();
